<div class="account p-4 mb-6">
  <div class="p-card-title flex justify-between items-center mb-4">
    New Account for {{ account.name }}
    <button
      pButton
      type="button"
      label="Discard account"
      class="p-button-danger p-button-text"
      (click)="discardAccount()"
    ></button>
  </div>
  @if (!isHHProviderType) {
    <div>
      <form [formGroup]="providerSearchForm">
        <div class="field mb-4">
          <label class="font-bold mr-2">Provider NPI:</label>
          <input
            type="text"
            pInputText
            placeholder="10 Digit NPI"
            formControlName="npi"
            (keypress)="preventEvent($event)"
          >
        </div>
      </form>
      <div class="flex">
        <div class="account-listbox-container">
          <p-listbox
            class="npi-list h-full"
            [multiple]="true"
            [checkbox]="true"
            [options]="searchResults"
            [(ngModel)]="selectedProviders"
            [pt]="{
              listContainer: { tabIndex: 0 },
              option: { ariaHidden: 'true' },
            }"
          >
            <p-header>
              @if (isLoading) {
                <p-progressSpinner
                  [style]="{ width: '20px', height: '20px' }"
                ></p-progressSpinner>
              }
              @if (!isLoading) {
                <span>
                    @if (isProviderNotFound) {
                      No NPI Found
                    }
                  @if (!isProviderNotFound) {
                    <span class="font-bold">Available Providers</span>
                  }
                  </span>
              }
            </p-header>
          </p-listbox>
        </div>
        <div class="m-4 flex items-center">
          <button
            pButton
            class="p-button-sm"
            icon="pi pi-chevron-right"
            [disabled]="!selectedProviders.length"
            (click)="addAccount()"
          ></button>
        </div>
        <div class="account-listbox-container">
          <p-listbox
            class="h-full npi-list"
            [options]="addedProviders"
            [multiple]="true"
            [checkbox]="true"
            [(ngModel)]="selectedAddedProviders"
            [pt]="{
              listContainer: { tabIndex: 0 },
              option: { ariaHidden: 'true' },
            }"
          />
        </div>
      </div>
      <div class="flex justify-end pt-4">
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          label="Remove selected"
          class="p-button-warning"
          [disabled]="!selectedAddedProviders.length"
          (click)="removeSelectedProviders()"
        ></button>
      </div>
    </div>
  }
</div>

<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
  [ptOptions]="{ mergeSections: true }"
  [pt]="{
    title: { role: 'heading', 'aria-level': '2' }
  }"
></p-confirmDialog>

